<template>
  <div class="home">
    <h2>🎉🎺 Welcome to the second undistinguished puzzle hunt! 🎺🎉</h2>
    <h6>Now featuring unicode support, more time to breathe, a brand new hint system, and <i>slightly</i> less bad web security!</h6>
    <p class="desc">
      The second undistinguished puzzle hunt ended at 7:25pm on Sep 14, 2018, when <span class="team">Honey Badgers</span> solved the enigmeta machine and won the hunt (<span class="team">Broke AF and need the pr</span> snuck in with a meta solve before submissions were closed). You can now see all puzzles and check answers on their individual pages. 

      Thanks to everyone for playing!
    </p>
    <Scoreboard />
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Scoreboard from '@/components/Scoreboard.vue'

export default {
  name: 'home',
  components: {
    // HelloWorld,
    Scoreboard
  }
}
</script>

<style lang="scss" scoped>
  .home {
    width: 80%;
	  margin: 0 auto;
  }

  .desc {
    font-style: italic;
    .team {
      font-variant: small-caps;
    }

  }
</style>